function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlookLogo = function SvgOutlookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 103.173 104.313"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M64.567 22.116v20.405l7.13 4.49c.188.054.596.058.784 0l30.688-20.69c0-2.45-2.284-4.205-3.573-4.205z",
    style: {
      fill: "#0072c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.567 50.133 6.507 4.47c.917.674 2.022 0 2.022 0-1.101.674 30.077-20.036 30.077-20.036V72.07c0 4.083-2.613 5.795-5.551 5.795h-33.06v-27.73z",
    style: {
      fill: "#0072c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.321 20.958q-.85 0-1.35.797-.5.796-.5 2.109 0 1.332.5 2.106.5.775 1.31.774.836 0 1.325-.753.49-.753.49-2.09 0-1.393-.475-2.169-.475-.774-1.3-.774",
    style: {
      fill: "#0072c6"
    },
    transform: "translate(-13.481 -41.384)scale(3.91787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.441 13.563v20.375l15.5 3.25V10.563zm10.372 13.632q-.982 1.293-2.563 1.294-1.54 0-2.51-1.253t-.97-3.266q0-2.125.985-3.438.986-1.313 2.61-1.313 1.535 0 2.482 1.256t.948 3.313q.001 2.114-.982 3.407",
    style: {
      fill: "#0072c6"
    },
    transform: "translate(-13.481 -41.384)scale(3.91787)"
  }));
};
export default SvgOutlookLogo;